const uz = {
    meta: {
        title: "Biznes avtomatlashtirish qayerdan boshlanadi | Innobek",
        description:
            "Biznes avtomatlashtirish qayerdan boshlanadi: jarayon xaritasi, to'rt bosqich, narx 15 mln so'mdan, ochiq ROI formulasi va qachon mos emasligi.",
        keywords: [
            "biznes avtomatlashtirish qayerdan boshlanadi",
            "biznes jarayonlarini avtomatlashtirish",
            "avtomatlashtirish narxi O'zbekiston",
            "avtomatlashtirish qachon o'zini oqlaydi",
            "jarayon xaritasi tuzish",
            "CRM joriy etish qaytimi",
        ],
    },
    h1: "Biznes avtomatlashtirish: yo'l xaritasi, narx va qaytim hisobi",
    lead:
        "Avtomatlashtirish dasturdan emas, jarayondan boshlanadi. Bu maqolada to'rt bosqichli yo'l xaritasi, O'zbekistondagi real narx oralig'i va qaytim formulasi ochiq beriladi — o'z raqamlaringizni qo'yib chiqishingiz uchun.",
    category: "Avtomatlashtirish",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Avtomatlashtirish haqidagi suhbat ko'pincha noto'g'ri savoldan boshlanadi: «bizga qaysi dastur kerak?» To'g'ri savol boshqacha: «kompaniyada qaysi bitta ish eng ko'p pul yeyapti?» Dastur — javob, lekin savol aniq bo'lmasa, javob ham bo'lmaydi. Aks holda siz buzuq jarayonni shunchaki ekranga ko'chirasiz.",
        },

        { type: "h2", text: "Avtomatlashtirish koddan emas, jarayondan boshlanadi" },
        {
            type: "p",
            text:
                "Avtomatlashtirish — takrorlanuvchi ishni odam qo'lidan olib, tizimga berish. Ariza bazaga o'zi tushadi, hujjat o'zi shakllanadi, muddat o'tganda eslatma o'zi ketadi. Texnik jihatdan bu eng oson qism.",
        },
        {
            type: "p",
            text:
                "Qiyin qismi — jarayonning o'zi. Agar bugun ariza kimga borishi kayfiyat va qo'ng'iroq tezligiga bog'liq bo'lsa, tizim buni tuzatmaydi. U faqat tartibsizlikni tezlashtiradi va endi tartibsizlik jurnalda yozilib turadi. Shuning uchun birinchi ish — jarayonni kelishib olish, keyin uni raqamlashtirish.",
        },
        {
            type: "callout",
            text:
                "Eng qimmat xato: kompaniya tizim sotib oladi, lekin kim nima qilishini oldindan kelishmaydi. Natijada tizim ishlatilmaydi, xodimlar Excel'ga qaytadi, pul esa yonadi.",
        },
        {
            type: "p",
            text:
                "2026-yilda bu masalani kechiktirib bo'lmaydi. PP-190 (23.05.2025) bo'yicha 1-iyuldan markirovka qilingan tovar sotilganda kod onlayn-KKM chekida aks etishi shart, ulgurji savdoda hisob-kitob esa faqat naqdsiz. Markirovka qoidalari buzilishini aniqlash tekshiruvi 1-yanvardan masofadan, soliq organlari axborot tizimi orqali o'tkaziladi. Ya'ni ma'lumot baribir raqamli bo'ladi — savol faqat shundaki, uni siz boshqarasizmi yoki u sizni.",
        },

        { type: "h2", text: "Birinchi qadam: jarayonni qog'ozga chizish" },
        {
            type: "p",
            text:
                "Hech qanday dastur tanlamasdan turib, bitta jarayonni boshdan oxirigacha chizing. Doska yoki oddiy qog'oz yetadi. Maqsad — ishning qayerda to'xtab qolishini ko'rish.",
        },
        {
            type: "list",
            items: [
                "Boshlanish nuqtasi: mijoz murojaati qayerdan kiradi — qo'ng'iroq, Telegram, sayt formasi, do'kon?",
                "Har bir qadam: kim bajaradi, qancha vaqt oladi, natija qayerda saqlanadi.",
                "Qo'lda kiritish nuqtalari: bir xil ma'lumot necha marta qayta yoziladi.",
                "Kutish nuqtalari: ish kimningdir tasdig'ini yoki javobini kutib turadigan joylar.",
                "Chiqish nuqtasi: jarayon nima bilan tugaydi — hujjat, to'lov, yetkazib berish?",
            ],
        },
        {
            type: "p",
            text:
                "Chizma tayyor bo'lgach, ikkita rangli marker oling. Birinchisi bilan qo'lda takrorlanadigan ishni, ikkinchisi bilan kutish joylarini belgilang. Odatda shu ikki rang butun muammoni ko'rsatib beradi — va tizimdan nima talab qilish kerakligi o'zi ayon bo'ladi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Qaysi jarayondan boshlash kerak?" },
        {
            type: "p",
            text:
                "Hammasini birdan avtomatlashtirish — eng ko'p uchraydigan va eng qimmat xato. Bitta nuqtani tanlang. Tanlov mezonlari oddiy va ular ketma-ket qo'llaniladi.",
        },
        {
            type: "ol",
            items: [
                "Qaysi jarayon eng ko'p soat yeydi? Haftalik soatni xodim soniga ko'paytiring.",
                "Qaysi jarayonda xato eng qimmatga tushadi? Yo'qotilgan ariza, noto'g'ri qoldiq, kechikkan yetkazib berish.",
                "Qaysi jarayon o'sishga to'sqinlik qilyapti? Buyurtma ikki barobar ko'paysa, qayeri birinchi bo'lib yorilib ketadi.",
                "Qaysi jarayonda ma'lumot allaqachon bor? Ma'lumoti bor joy tezroq ishga tushadi va tezroq natija beradi.",
            ],
        },
        {
            type: "p",
            text:
                "To'rt savolga javob bergach, odatda bitta jarayon aniq yetakchilik qiladi. Aksariyat savdo va xizmat kompaniyalarida bu — arizani qabul qilish va uni menejerga biriktirish. Ishlab chiqarish va ulgurjida esa ombor qoldig'i birinchi o'rinda turadi.",
        },

        { type: "h2", text: "Avtomatlashtirish O'zbekistonda qancha turadi?" },
        {
            type: "p",
            text:
                "Narx jarayonlar soni va integratsiyalar murakkabligiga bog'liq. Quyida Innobek amaliyotidagi uchta daraja — bular boshlang'ich chegaralar, yakuniy summa bepul tahlildan keyin aniqlanadi.",
        },
        {
            type: "table",
            head: ["Daraja", "Narx (so'mdan)", "Muddat", "Nimani yopadi"],
            rows: [
                [
                    "Bitta jarayon",
                    "15 000 000",
                    "3–5 hafta",
                    "Bitta bo'limning bitta og'riqli vazifasi: ariza, hujjat yoki hisobot",
                ],
                [
                    "Bo'lim darajasi",
                    "45 000 000",
                    "2–3 oy",
                    "Sotuv, ombor yoki servis boshdan oxirigacha, 1C va bank integratsiyasi bilan",
                ],
                [
                    "Kompaniya darajasi",
                    "110 000 000",
                    "4–8 oy",
                    "Bir nechta bo'lim va filial, ERP modullari, yagona ma'lumot bazasi",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Narxga nima kirmasligini ham ochiq aytamiz. Server yoki bulut xarajati alohida va to'g'ridan-to'g'ri provayderga to'lanadi. Ishga tushirilgandan keyingi texnik qo'llab-quvvatlash oyiga 3 500 000 so'mdan. Uchinchi tomon xizmatlari — to'lov tizimi, SMS, telefoniya — o'z tariflari bo'yicha. Narxlarga QQS kiritilmagan.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Qachon o'zini oqlaydi — ochiq hisob" },
        {
            type: "p",
            text:
                "Qaytim ikki manbadan yig'iladi: tejalgan vaqt va yo'qotilmagan bitim. Formula oddiy, siz faqat o'z raqamlaringizni qo'yasiz.",
        },
        {
            type: "list",
            items: [
                "Tejalgan pul = (haftada tejalgan soat × xodim soni × 4,3) × soat tannarxi.",
                "Yo'qotilmagan tushum = oyiga yo'qoladigan ariza × konversiya × o'rtacha chek.",
                "Qaytish muddati (oy) = loyiha narxi ÷ (tejalgan pul + yo'qotilmagan tushum).",
            ],
        },
        {
            type: "p",
            text:
                "Misol. Savdo bo'limida 4 ta menejer bor, har biri kuniga 1,5 soatni qo'lda hisobot, Excel to'ldirish va ariza qidirishga sarflaydi. Oyiga 22 ish kuni: 4 × 1,5 × 22 = 132 soat. Menejerning soat tannarxi ish haqi, soliq va ish joyi bilan 45 000 so'm bo'lsa — oyiga 5 940 000 so'm. Ikkinchi qism: oyiga 120 ta murojaat keladi, 8 foizi javobsiz qoladi yoki kech javob oladi — bu 10 ta ariza. Konversiya 20 foiz, o'rtacha chek 3 mln so'm: 10 × 0,2 × 3 = 6 mln so'm yo'qotilgan tushum. Jami oyiga taxminan 11,9 mln so'm.",
        },
        {
            type: "p",
            text:
                "Bitta jarayon darajasidagi loyiha 15 mln so'mdan. Agar tizim bu yo'qotishning yarmini yopsa — oyiga 6 mln so'm — qaytish muddati 15 ÷ 6 ≈ 2,5 oy. Uchdan birini yopsa, taxminan 4 oy. Halol ogohlantirish: birinchi 1–2 oyda samara deyarli nolga teng, chunki xodimlar o'rganadi va eski odatga qaytishga urinadi. Shuning uchun realroq hisobda qaytish muddatiga 2 oy qo'shib qo'ying.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Hech narsa qilmaslikning narxi qancha?" },
        {
            type: "p",
            text:
                "Yuqoridagi misoldagi kompaniya uchun harakatsizlik narxi oyiga 11,9 mln so'm. Uch yilda bu 428 mln so'm — kompaniya darajasidagi to'liq loyihadan ham ko'p. Lekin pul yagona yo'qotish emas.",
        },
        {
            type: "list",
            items: [
                "Ma'lumot bitta odamda qoladi. U ta'tilga chiqsa yoki ishdan ketsa, hisobot bilan birga ketadi.",
                "Qaror kechikadi. Rahbar oyning 10-kunida o'tgan oy raqamini ko'rsa, tuzatish uchun vaqt qolmaydi.",
                "Tekshiruvga tayyorgarlik kunlarni oladi. Masofaviy soliq nazorati sharoitida bu jiddiy xavf.",
                "O'sish to'xtaydi. Qo'lda boshqariladigan jarayon buyurtma hajmi ikki barobar oshganda sinadi.",
            ],
        },
        {
            type: "p",
            text:
                "Kontekst ham o'zgardi. 2026-yil 26-maydagi PF-100 farmoni bilan 1-iyundan QQS ga o'tish chegarasi 1 mlrd so'mdan 12 000 BHM — taxminan 5 mlrd so'mgacha ko'tarildi. Ko'p kompaniya shundan keyin o'sish rejasini kengaytirdi, o'sish esa qo'lda yuritilgan hisobni birinchi bo'lib sindiradi.",
        },

        { type: "h2", text: "Avtomatlashtirish qachon mos emas?" },
        {
            type: "p",
            text:
                "Bu bo'limni yozmaslik oson bo'lardi, lekin pul isrof bo'lishining oldini olish muhimroq. Quyidagi holatlarda tizimga shoshilmang.",
        },
        {
            type: "list",
            items: [
                "Jarayon hali barqaror emas. Har oy ish tartibi o'zgarayotgan bo'lsa, tizim qotib qolgan qolipga aylanadi.",
                "Hajm kichik. Oyiga 20–30 ta ariza kelsa, yaxshi tuzilgan jadval va aniq reglament yetarli.",
                "Muammo odamlarda, dasturda emas. Menejer qo'ng'iroq qilmasa, tizim uning o'rniga qo'ng'iroq qilmaydi.",
                "Ichkarida egasi yo'q. Loyihani olib boradigan, qaror qabul qiladigan xodim tayinlanmagan bo'lsa, joriy etish cho'ziladi.",
                "Byudjet faqat ishlab chiqishga yetadi. Qo'llab-quvvatlash va o'qitishga pul qolmasa, tizim bir yilda eskiradi.",
            ],
        },
        {
            type: "p",
            text:
                "Markaziy Osiyoda sanoat kompaniyalarining 53 foizi sun'iy intellektni o'lchanadigan samara bilan ishlatadi — KPMG Tech Report 2026 ma'lumoti, global ko'rsatkich 24 foiz. Bu raqam bosim o'tkazish uchun emas: agar yuqoridagi beshta banddan biri sizga tegishli bo'lsa, raqobatchiga qarab shoshilish faqat zarar keltiradi.",
        },

        { type: "h2", text: "To'rt bosqichli yo'l xaritasi" },
        {
            type: "ol",
            items: [
                "Jarayonni chizish va o'lchash. 3–5 kun. Natija: hozirgi jarayon chizmasi va yo'qotilayotgan soat hisobi.",
                "Eng qimmat nuqtani tanlash va kichik modul qurish. 3–5 hafta. Bitta jarayon, 2–3 ta integratsiya, 5 tagacha foydalanuvchi.",
                "O'lchash va tuzatish. 4–8 hafta. Xuddi shu ko'rsatkichni qayta o'lchaysiz: soat kamaydimi, ariza yo'qolmaydimi.",
                "Kengaytirish. Birinchi modul raqam bilan o'zini oqlagach, keyingi bo'limga o'tasiz — CRM, ombor yoki hujjat aylanishi.",
            ],
        },
        {
            type: "p",
            text:
                "Bu tartibning asosiy afzalligi — butun byudjetni bir yo'la ajratish shart emas. Har bosqich alohida to'lanadi va alohida ishga tushadi. Agar birinchi modul kutilgan natijani bermasa, siz 110 mln emas, 15 mln so'm bilan to'xtaysiz va sababini bilib olasiz.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Birinchi haftada nima qilish mumkin" },
        {
            type: "ol",
            items: [
                "Bitta jarayonni tanlang va uni qadamma-qadam yozib chiqing.",
                "Har qadamga sarflanadigan vaqtni ikki hafta davomida o'lchang — taxmin qilmang.",
                "Soat tannarxini hisoblang: ish haqi, soliq va ish joyi xarajati bo'linadi oyiga ishlanadigan soatga.",
                "Yuqoridagi formulaga qo'ying va yo'qotish summasini oling.",
                "Shu summa loyiha narxining yarmidan ko'p bo'lsa — boshlash mantiqiy.",
            ],
        },
        {
            type: "p",
            text:
                "Aynan shu tartibda ishlaganda avtomatlashtirish xarajat bandidan aktivga aylanadi. Agar hisob boshlashga arzimasligini ko'rsatsa, bu ham qimmatli natija — siz noto'g'ri loyihaga pul sarflamadingiz.",
        },
    ],

    faq: [
        {
            q: "Avtomatlashtirishni qaysi dasturdan boshlash kerak?",
            a: "Dasturdan emas, jarayondan. Avval bitta jarayonni chizib, unda qancha soat va qancha ariza yo'qolayotganini o'lchang. Shundan keyin qaysi vosita kerakligi o'zi ayon bo'ladi: ba'zi holatda bu CRM, ba'zida ombor moduli, ba'zida esa oddiy Telegram bot yetadi. Teskari tartibda ishlansa, sotib olingan dastur jarayonga mos kelmay qoladi va ishlatilmaydi.",
        },
        {
            q: "Kichik biznesga avtomatlashtirish kerakmi?",
            a: "Hajmga bog'liq. Oyiga 20–30 ta ariza kelsa va jamoa uch kishidan iborat bo'lsa, yaxshi tuzilgan jadval hamda aniq reglament yetadi. Oyiga 100 dan ortiq murojaat, bir nechta menejer yoki ombor qoldig'i paydo bo'lganda esa qo'lda hisob xato bera boshlaydi. Aniq chegara — ma'lumotni bir joyda ushlab turish qiyinlasha boshlagan payt.",
        },
        {
            q: "Avtomatlashtirish qancha vaqtda o'zini oqlaydi?",
            a: "Bitta jarayon darajasidagi loyihada odatda 3–6 oy. Hisob oddiy: loyiha narxini oylik tejalgan pul va yo'qotilmagan tushum yig'indisiga bo'lasiz. Muhim ogohlantirish — birinchi 1–2 oyda samara deyarli bo'lmaydi, chunki jamoa yangi tartibga o'rganadi. Shuning uchun hisoblangan muddatga ikki oy qo'shib qo'ying va natijani o'sha nuqtada baholang.",
        },
        {
            q: "Tayyor dastur olgan ma'qulmi yoki o'z tizimimi?",
            a: "Jarayon standart bo'lsa va jamoa kichik bo'lsa, tayyor yechim tezroq va arzonroq start beradi. O'z tizimi jarayoningiz bozordagi qolipga sig'masa, integratsiya chuqur bo'lsa yoki foydalanuvchi soni o'sib borayotgan bo'lsa foydali. Uch yillik xarajatni ikki variant uchun ham hisoblab ko'ring — qaror odatda shu jadvaldan keyin aniq bo'ladi.",
        },
        {
            q: "Xodimlar yangi tizimni ishlatmasa nima bo'ladi?",
            a: "Bu eng ko'p uchraydigan muvaffaqiyatsizlik sababi. Oldini olish uchun uchta shart bor: tizim eski usuldan tezroq ishlashi kerak, ichkarida javobgar egasi bo'lishi kerak, va eski kanal bir muddatdan keyin yopilishi kerak. Agar Excel parallel ishlab tursa, jamoa har doim unga qaytadi. O'qitish bir martalik emas, ikki-uch sessiya bo'lgani ma'qul.",
        },
        {
            q: "Avtomatlashtirish narxiga nima kirmaydi?",
            a: "Server yoki bulut xarajati alohida va to'g'ridan-to'g'ri provayderga to'lanadi. Ishga tushirilgandan keyingi texnik qo'llab-quvvatlash oyiga 3 500 000 so'mdan hisoblanadi. Uchinchi tomon xizmatlari — to'lov tizimi, SMS tarqatish, IP-telefoniya — o'z tariflari bo'yicha to'lanadi. Narxlarga QQS kiritilmagan. Bu bandlarni byudjetga oldindan kiritish kerak.",
        },
    ],

    cta: {
        h: "Jarayoningizni bepul tahlil qilamiz",
        p:
            "2–5 kun ichida jarayoningizni o'rganamiz, qayerda qancha vaqt va pul yo'qotilayotganini raqamda ko'rsatamiz hamda yozma taklif yuboramiz. Avtomatlashtirish sizga hozir foydali bo'lmasa, buni ochiq aytamiz.",
        button: "Bepul tahlil so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/avtomatlashtirish-jarayon-xaritasi.webp",
            alt: "Jamoa doskada biznes jarayonini chizmoqda, to'siq nuqtasi qizil marker bilan belgilangan",
            caption: "Birinchi qadam — kod emas, jarayon xaritasi",
            prompt:
                "Workshop scene: a team standing in front of a whiteboard covered with a hand-drawn business process map — sticky notes, swimlanes and arrows; one bottleneck circled in red marker; warm office lighting, documentary style, faces not prominent, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/avtomatlashtirish-yol-xaritasi.webp",
            alt: "Avtomatlashtirishning to'rt bosqichli yo'l xaritasi: chizish, tanlash, qurish, o'lchash",
            caption: "To'rt bosqich: chizish, tanlash, kichik moduldan boshlash, o'lchash",
            prompt:
                "Four-stage roadmap infographic: map the process, pick the costliest bottleneck, build the smallest module, measure and expand; horizontal stepped layout with icons, blue gradient progression, clean flat vector, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/avtomatlashtirish-roi-paneli.webp",
            alt: "Avtomatlashtirish ROI hisobi paneli — tejalgan soat, oylik tejamkorlik va qaytish muddati",
            caption: "Qaytim ikki manbadan: tejalgan soat va yo'qotilmagan bitim",
            prompt:
                "ROI calculation panel: left side inputs (hours saved per week, cost per hour, lost deals recovered), right side output tiles (monthly saving, payback months, three-year value); clean light dashboard, blue and green accents, numeric placeholders as dashes, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/tezlift.webp",
            alt: "Tez Lift — arizalar, brigadalar va texnik ko'rik jadvali bitta tizimda birlashtirilgan",
            caption: "Tez Lift: bitta moduldan boshlab bosqichma-bosqich o'sgan tizim",
        },
    ],

    relatedServices: ["biznes-avtomatlashtirish", "crm-tizimlar", "erp-tizimlar"],
    relatedPosts: [
        "tayyor-crm-yoki-oz-crm-tco",
        "excel-dan-erp-ga-otish-signallari",
        "telegram-bot-nimani-avtomatlashtiradi",
    ],
};

const ru = {
    meta: {
        title: "С чего начать автоматизацию бизнеса: цена и ROI | Innobek",
        description:
            "С чего начать автоматизацию бизнеса: карта процессов, четыре этапа, цена от 15 млн сум, открытая формула ROI и случаи, когда автоматизация не нужна.",
        keywords: [
            "с чего начать автоматизацию бизнеса",
            "автоматизация бизнес-процессов Узбекистан",
            "стоимость автоматизации бизнеса",
            "окупаемость внедрения CRM",
            "карта бизнес-процессов как составить",
            "этапы автоматизации компании",
        ],
    },
    h1: "Автоматизация бизнеса: дорожная карта, цена и расчёт окупаемости",
    lead:
        "Автоматизация начинается не с программы, а с процесса. В статье — четыре этапа внедрения, реальный диапазон цен по Узбекистану и открытая формула окупаемости, в которую вы подставите свои цифры.",
    category: "Автоматизация",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "Разговор об автоматизации почти всегда начинается с неверного вопроса: «какая программа нам нужна?» Правильный вопрос другой: «какая одна операция в компании съедает больше всего денег?» Программа — это ответ, но без точного вопроса ответа не будет. Иначе вы просто перенесёте сломанный процесс на экран.",
        },

        { type: "h2", text: "Автоматизация начинается с процесса, а не с кода" },
        {
            type: "p",
            text:
                "Автоматизация — это передача повторяющейся работы от человека системе. Заявка сама попадает в базу, документ формируется сам, напоминание уходит без участия менеджера. Технически это самая простая часть задачи.",
        },
        {
            type: "p",
            text:
                "Сложное — сам процесс. Если сегодня заявка достаётся тому, кто первым взял трубку, система этого не исправит. Она лишь ускорит беспорядок — просто теперь он будет аккуратно записан в журнал. Поэтому сначала договариваются о процессе, и только потом его оцифровывают.",
        },
        {
            type: "callout",
            text:
                "Самая дорогая ошибка: компания покупает систему, но не договаривается заранее, кто за что отвечает. Система простаивает, сотрудники возвращаются в Excel, деньги сгорают.",
        },
        {
            type: "p",
            text:
                "В 2026 году откладывать это уже не получается. По ПП-190 от 23.05.2025 с 1 июля код маркировки должен отражаться в чеке онлайн-ККМ, а расчёты в оптовой торговле маркированным товаром идут только безналично. Проверки нарушений маркировки с 1 января проводятся дистанционно, через информационную систему налоговых органов. Данные всё равно станут цифровыми — вопрос только в том, управляете ими вы или они вами.",
        },

        { type: "h2", text: "Первый шаг: нарисовать процесс на бумаге" },
        {
            type: "p",
            text:
                "Ещё до выбора программы прорисуйте один процесс от начала до конца. Хватит доски или обычного листа. Цель — увидеть, где работа останавливается.",
        },
        {
            type: "list",
            items: [
                "Точка входа: откуда приходит обращение — звонок, Telegram, форма на сайте, торговая точка?",
                "Каждый шаг: кто выполняет, сколько времени занимает, где сохраняется результат.",
                "Точки ручного ввода: сколько раз одни и те же данные переписываются заново.",
                "Точки ожидания: где работа стоит и ждёт чьего-то согласования или ответа.",
                "Точка выхода: чем процесс заканчивается — документом, оплатой, отгрузкой?",
            ],
        },
        {
            type: "p",
            text:
                "Когда схема готова, возьмите два маркера. Первым отметьте ручную повторяющуюся работу, вторым — места ожидания. Обычно эти два цвета показывают всю проблему целиком, и требования к системе формулируются сами собой.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "С какого процесса начинать?" },
        {
            type: "p",
            text:
                "Автоматизировать всё сразу — самая частая и самая дорогая ошибка. Выберите одну точку. Критерии простые и применяются по порядку.",
        },
        {
            type: "ol",
            items: [
                "Какой процесс съедает больше всего часов? Умножьте недельные часы на число сотрудников.",
                "Где ошибка обходится дороже всего? Потерянная заявка, неверный остаток, сорванная отгрузка.",
                "Что мешает росту? Если заказов станет вдвое больше, какой участок сломается первым?",
                "Где данные уже есть? Участок с готовыми данными запускается быстрее и раньше даёт результат.",
            ],
        },
        {
            type: "p",
            text:
                "После четырёх ответов один процесс обычно вырывается вперёд. В торговле и сервисе это чаще всего приём заявки и её закрепление за менеджером. В производстве и опте на первом месте стоит складской остаток.",
        },

        { type: "h2", text: "Сколько стоит автоматизация в Узбекистане?" },
        {
            type: "p",
            text:
                "Цена зависит от количества процессов и сложности интеграций. Ниже три уровня из практики Innobek — это стартовые границы, итоговая сумма определяется после бесплатного анализа.",
        },
        {
            type: "table",
            head: ["Уровень", "Цена (от, сум)", "Срок", "Что закрывает"],
            rows: [
                [
                    "Один процесс",
                    "15 000 000",
                    "3–5 недель",
                    "Одна болевая задача одного отдела: заявка, документ или отчёт",
                ],
                [
                    "Уровень отдела",
                    "45 000 000",
                    "2–3 месяца",
                    "Продажи, склад или сервис целиком, с интеграцией 1С и банка",
                ],
                [
                    "Уровень компании",
                    "110 000 000",
                    "4–8 месяцев",
                    "Несколько отделов и филиалов, ERP-модули, единая база данных",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Честно говорим и о том, что в цену не входит. Сервер или облако оплачивается отдельно и напрямую провайдеру. Техническая поддержка после запуска — от 3 500 000 сум в месяц. Сторонние сервисы (платёжная система, SMS, телефония) идут по своим тарифам. НДС в цены не включён.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Когда это окупится — расчёт без скрытых допущений" },
        {
            type: "p",
            text:
                "Отдача складывается из двух источников: сэкономленного времени и несорванных сделок. Формула простая, вы подставляете свои цифры.",
        },
        {
            type: "list",
            items: [
                "Экономия = (сэкономленные часы в неделю × число сотрудников × 4,3) × себестоимость часа.",
                "Недополученная выручка = потерянные заявки в месяц × конверсия × средний чек.",
                "Срок окупаемости (мес.) = цена проекта ÷ (экономия + недополученная выручка).",
            ],
        },
        {
            type: "p",
            text:
                "Пример. В отделе продаж четыре менеджера, каждый тратит 1,5 часа в день на ручные отчёты, заполнение Excel и поиск заявок. При 22 рабочих днях: 4 × 1,5 × 22 = 132 часа. Если себестоимость часа с зарплатой, налогами и рабочим местом — 45 000 сум, это 5 940 000 сум в месяц. Вторая часть: приходит 120 обращений, 8 процентов остаются без ответа или получают его поздно — 10 заявок. При конверсии 20 процентов и среднем чеке 3 млн сум: 10 × 0,2 × 3 = 6 млн сум. Итого около 11,9 млн сум в месяц.",
        },
        {
            type: "p",
            text:
                "Проект уровня одного процесса стоит от 15 млн сум. Если система закроет половину потерь — 6 млн в месяц — окупаемость составит 15 ÷ 6 ≈ 2,5 месяца. Если треть, около 4 месяцев. Честное предупреждение: первые один-два месяца эффект близок к нулю, потому что команда учится и пытается вернуться к привычному. Поэтому к расчётному сроку добавьте два месяца.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Сколько стоит ничего не менять?" },
        {
            type: "p",
            text:
                "Для компании из примера бездействие стоит 11,9 млн сум в месяц. За три года это 428 млн сум — больше, чем полный проект уровня компании. Но деньги здесь не единственная потеря.",
        },
        {
            type: "list",
            items: [
                "Данные держатся на одном человеке. Уходит он — уходит и отчётность.",
                "Решения опаздывают. Руководитель видит цифры прошлого месяца десятого числа, когда исправлять уже поздно.",
                "Подготовка к проверке занимает дни. При дистанционном налоговом контроле это заметный риск.",
                "Рост упирается в потолок. Ручной процесс ломается на двукратном объёме заказов.",
            ],
        },
        {
            type: "p",
            text:
                "Изменился и контекст. Указом ПФ-100 от 26 мая 2026 года с 1 июня порог перехода на НДС поднят с 1 млрд сум до 12 000 БРВ — около 5 млрд сум. После этого многие компании расширили планы роста, а рост первым делом ломает ручной учёт.",
        },

        { type: "h2", text: "Когда автоматизация не нужна?" },
        {
            type: "p",
            text:
                "Этот раздел проще было бы не писать, но предотвратить пустые расходы важнее. В перечисленных ситуациях с системой лучше не спешить.",
        },
        {
            type: "list",
            items: [
                "Процесс ещё не устоялся. Если порядок работы меняется каждый месяц, система превратится в жёсткую форму, которая только мешает.",
                "Объём небольшой. При 20–30 заявках в месяц достаточно аккуратной таблицы и внятного регламента.",
                "Проблема в людях, а не в программе. Если менеджер не перезванивает, система не перезвонит за него.",
                "Внутри нет владельца проекта. Без сотрудника, принимающего решения, внедрение растягивается.",
                "Бюджета хватает только на разработку. Без денег на поддержку и обучение система устареет за год.",
            ],
        },
        {
            type: "p",
            text:
                "По данным KPMG Tech Report 2026, в Центральной Азии 53 процента промышленных компаний применяют ИИ с измеримым эффектом при мировом показателе 24 процента. Эта цифра приведена не для давления: если к вам относится хотя бы один пункт из пяти выше, гонка за конкурентом принесёт только убыток.",
        },

        { type: "h2", text: "Дорожная карта из четырёх этапов" },
        {
            type: "ol",
            items: [
                "Описать и измерить процесс. 3–5 дней. Результат — схема текущего процесса и расчёт теряемых часов.",
                "Выбрать самую дорогую точку и собрать небольшой модуль. 3–5 недель. Один процесс, 2–3 интеграции, до пяти пользователей.",
                "Измерить и доработать. 4–8 недель. Вы заново считаете тот же показатель: сократились ли часы, перестали ли теряться заявки.",
                "Расширять. После того как первый модуль окупился в цифрах, переходите к следующему участку — CRM, склад, документооборот.",
            ],
        },
        {
            type: "p",
            text:
                "Главное преимущество такого порядка — не нужно выделять весь бюджет сразу. Каждый этап оплачивается и запускается отдельно. Если первый модуль не даст ожидаемого результата, вы остановитесь на 15 млн сум, а не на 110 млн, и будете точно знать причину.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Что можно сделать уже на этой неделе" },
        {
            type: "ol",
            items: [
                "Выберите один процесс и распишите его по шагам.",
                "Две недели измеряйте фактическое время на каждом шаге — не оценивайте на глаз.",
                "Посчитайте себестоимость часа: зарплата, налоги и рабочее место, делённые на месячные часы.",
                "Подставьте цифры в формулу выше и получите сумму потерь.",
                "Если она превышает половину стоимости проекта — начинать имеет смысл.",
            ],
        },
        {
            type: "p",
            text:
                "Именно в таком порядке автоматизация перестаёт быть строкой расходов и становится активом. А если расчёт покажет, что начинать рано, это тоже ценный результат: вы не потратили деньги на ненужный проект.",
        },
    ],

    faq: [
        {
            q: "С какой программы начинать автоматизацию?",
            a: "Начинать нужно не с программы, а с процесса. Сначала опишите один процесс и измерьте, сколько часов и заявок в нём теряется. После этого нужный инструмент определится сам: иногда это CRM, иногда складской модуль, а иногда достаточно простого Telegram-бота. В обратном порядке купленная программа не совпадёт с процессом, и ею просто не будут пользоваться.",
        },
        {
            q: "Нужна ли автоматизация малому бизнесу?",
            a: "Зависит от объёма. При 20–30 заявках в месяц и команде из трёх человек хватает аккуратной таблицы и понятного регламента. Когда обращений становится больше сотни, появляются несколько менеджеров или складские остатки, ручной учёт начинает врать. Точный признак — момент, когда удерживать данные в одном месте становится тяжело.",
        },
        {
            q: "За какой срок автоматизация окупается?",
            a: "Для проекта уровня одного процесса обычно за 3–6 месяцев. Расчёт простой: стоимость проекта делится на сумму месячной экономии и несорванной выручки. Важная оговорка — в первые один-два месяца эффекта почти нет, команда осваивает новый порядок. Поэтому к расчётному сроку стоит добавить два месяца и оценивать результат в этой точке.",
        },
        {
            q: "Что выгоднее: готовая программа или своя система?",
            a: "Если процесс стандартный, а команда небольшая, готовое решение даёт более быстрый и дешёвый старт. Своя система оправдана, когда процесс не укладывается в рыночный шаблон, интеграции глубокие или число пользователей растёт. Посчитайте трёхлетние расходы для обоих вариантов — после такой таблицы решение обычно становится очевидным.",
        },
        {
            q: "Что делать, если сотрудники не пользуются новой системой?",
            a: "Это самая частая причина провала внедрения. Предотвращают её три условия: система должна работать быстрее прежнего способа, внутри нужен ответственный владелец, а старый канал через какое-то время нужно закрыть. Если Excel продолжает работать параллельно, команда всегда будет возвращаться к нему. Обучение лучше проводить не разово, а в две-три сессии.",
        },
        {
            q: "Что не входит в стоимость автоматизации?",
            a: "Сервер или облако оплачивается отдельно и напрямую провайдеру. Техническая поддержка после запуска считается от 3 500 000 сум в месяц. Сторонние сервисы — платёжная система, SMS-рассылка, IP-телефония — идут по собственным тарифам. НДС в цены не включён. Эти статьи стоит заложить в бюджет заранее, чтобы запуск не оказался дороже ожидаемого.",
        },
    ],

    cta: {
        h: "Бесплатно разберём ваш процесс",
        p:
            "За 2–5 дней изучим процесс, покажем в цифрах, где теряются время и деньги, и пришлём письменное предложение. Если автоматизация вам сейчас не нужна, скажем об этом прямо.",
        button: "Запросить бесплатный анализ",
    },

    images: [
        {
            src: "/assets/img/blog/avtomatlashtirish-jarayon-xaritasi.webp",
            alt: "Команда рисует карту бизнес-процесса на доске, узкое место отмечено красным маркером",
            caption: "Первый шаг — не код, а карта процесса",
            prompt:
                "Workshop scene: a team standing in front of a whiteboard covered with a hand-drawn business process map — sticky notes, swimlanes and arrows; one bottleneck circled in red marker; warm office lighting, documentary style, faces not prominent, no readable text, 16:9",
        },
        {
            src: "/assets/img/blog/avtomatlashtirish-yol-xaritasi.webp",
            alt: "Четырёхэтапная дорожная карта автоматизации: описать, выбрать, собрать, измерить",
            caption: "Четыре этапа: описать, выбрать точку, собрать модуль, измерить",
            prompt:
                "Four-stage roadmap infographic: map the process, pick the costliest bottleneck, build the smallest module, measure and expand; horizontal stepped layout with icons, blue gradient progression, clean flat vector, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/avtomatlashtirish-roi-paneli.webp",
            alt: "Панель расчёта ROI автоматизации — сэкономленные часы, экономия и срок окупаемости",
            caption: "Отдача складывается из сэкономленных часов и несорванных сделок",
            prompt:
                "ROI calculation panel: left side inputs (hours saved per week, cost per hour, lost deals recovered), right side output tiles (monthly saving, payback months, three-year value); clean light dashboard, blue and green accents, numeric placeholders as dashes, no logos, 16:9",
        },
        {
            src: "/assets/img/projects/tezlift.webp",
            alt: "Tez Lift — заявки, бригады и график техосмотра объединены в одной системе",
            caption: "Tez Lift: система, выросшая поэтапно из одного модуля",
        },
    ],

    relatedServices: ["biznes-avtomatlashtirish", "crm-tizimlar", "erp-tizimlar"],
    relatedPosts: [
        "tayyor-crm-yoki-oz-crm-tco",
        "excel-dan-erp-ga-otish-signallari",
        "telegram-bot-nimani-avtomatlashtiradi",
    ],
};

const content = { uz, ru };

export default content;
